export default {

  //Site
  "olympus.logo_big_title": "Olympus",

  // Page Titles
  "olympus.login": "Olympus",
  "olympus.forgot_password": "Forgot Password: Olympus",
  "olympus.reset_password": "Reset Password: Olympus",
  "olympus.generic_page.coming_soon": "Coming soon: Olympus",
  "olympus.generic_page.not_found": "Page not found: Olympus",
  "olympus.data_search": "Data Search: Olympus",
  "olympus.saved_search": "Saved Search: Olympus",
  "olympus.settings": "Settings: Olympus",
  "olympus.add_data": "Add Data: Olympus",
  "olympus.enrich": "Enrich: Olympus",
  "olympus.history": "History: Olympus",
  "olympus.audit_dashboard": "Audit Dashboard: Olympus",

  // Common texts
  "email": "email",
  "username": "username",
  "password": "password",
  "new_password": "new password",
  "old_password": "old password",
  "confirm_password": "confirm password",
  "privacy_policy": "privacy policy",
  "terms_and_conditions": "Terms & Condition",
  "change_password": "change password",
  "logout": "Logout",
  "start_date": "start date",
  "end_date": "end date",
  "action": "action",
  "empty": "empty",
  "date": "date",
  "settings": "settings",
  "user": "user",
  "agency": "agency",
  "client": "client",
  "image": "image",
  "file": "file",
  "fields": "fields",
  "brief": "brief",
  "lead": "lead",
  "search": "search",
  "asset": "asset",
  "delete": "delete",
  "download": "download",
  "campaign": "campaign",

  // Common labels
  "label.select_field": "select {field}",
  "label.yes": "yes",
  "label.no": "no",

  // Modal
  "modal.confirm": "confirm",
  "modal.alert": "alert !",

  // Record count display
  "page_records_of_total": "page {currentPage} out of {totalPages}",

  //Menu
  "menu.data_search": "Data Search",
  "menu.add_data": "Add Data",
  "menu.enrich": "Enrich",
  "menu.history": "History",
  "menu.terms_and_conditions": "terms & conditions",

  // error validation messages
  "error.required": "{field} is required.",
  "error.are_required": "{field} are required.",
  "error.select": "Please select {field}.",
  "error.select_atleast_one": "Please select at least one {field}.",
  "error.select_atleast_one_with_operation": "Please select at least one {field} to {operation}.",
  "error.select_only_one": "Please select only one {field}.",
  "error.select_single": "Please select single {field}.",
  "error.enter": "Please enter {field}.",
  "error.valid": "Please enter valid {field}.",
  "error.select_valid": "Please select valid {field}.",
  "error.invalid": "Invalid {field}.",
  "error.invalid_rate_value": "rate should be a number with up to 2 decimal points, less than 8 digits.",
  "error.password_not_match": "Confirm password does not match.",
  "error.password_min_char": "Password should contains minimum 8 characters.",
  "error.password_valid_char": "Password must be at least 8 characters long and contain an uppercase letter, a number, and a special character.",
  "error.exact_number_field": "Please enter {value} number {field}.",
  "error.less_than_value": "{field} should be less than {value}.",
  "error.atleast_value": "{field} should be atleast {value}.",
  "error.something_error": "There is some error inside the fields.",
  "error.less_than_value_character": "{field} should be less than {value} characters.",
  "error.after_start_date": "End date field should be after start date",
  "error.after_start_time": "End time should be after start time",
  "error.after_today": "End date should be today or future date.",
  "error.start_after_today": "Start date should be today or future date.",
  "error.date_after_today": "Date should be today or future date.",
  "error.greater_than_value": "{field} should be greater than {value}.",
  "error.greatereq_than_value": "{field} should be greater than or equal to {value}.",
  "error.image_upload": "Image not uploaded successfully",
  "error.after_date": "{field} should be greater than or equal to current date",
  "error.any_one_option_required": "Anyone option should be enable for {field}",
  "error.not_matched_with_val": "{field} not matched with {value}",
  "error.please_remove_uploaded_file": "Please remove uploaded file",
  "error.please_fill_up_the_proper_details": "Please fill up the proper details.",
  "error.campaign_id_is_missing": "Campaign id is missing, Please contact support team.",
  "error.file_size_is_larger_than": "File size is larger than {size} MB.",
  "error.select_atleast_one_filter": "Please select at least one filter.",

  // Success message
  "success.updated_successfully": "{field} updated successfully.",
  "success.lead_status_updated_success": "Lead {status} successfully",
  "success.lead_search_initiated": "Lead search initiated successfully.",

  //Placeholder
  "placeholder.select": "Select",
  "placeholder.select_field": "Select {field}",
  "placeholder.enter_field": "Enter {field}",
  "placeholder.please_enter_field": "Please enter {field}",
  "placeholder.fix_field": "Fix {field}",
  "placeholder.search": "search",
  "placeholder.select_all": "select all",
  "placeholder.start_typing_to_search": "start typing to search",

  // Message
  "message.no_found_data": "no data found",
  "message.this_action_will_reset_all_your_form_data": "Note: This action will reset all your form data",
  "message.access_error": "You don't have access to visit this page.",
  "message.file_generated_successfully": "File generated successfully.",
  "message.file_generation_failed": "Failed to generate file.",

  // Confirm message
  "confirm.are_you_sure": "Are you sure want to {field}?",
  "confirm.are_you_sure_delete": "Are you sure want to delete {field}?",

  // File upload
  "file.browse": "Drop file here or click to browse",
  "file.attach_file": "attach file",
  "file.no_file_selected": "No file selected.",
  "file.file_upload": "file upload",
  "file.drop_file_here_or_click_to_upload": "Drop files here or click to upload",
  "file.allowed_files": "Allowed file extensions : {allowedExtensions}",
  "file.file_name": "file name",
  "file.required_fields": "required fields",
  "file.invalid_values": "invalid values",
  "file.email": "email:",
  "file.row": "row:",
  "file.reasons": "reasons:",
  "file.reason_item": "{key} : {reason}",
  "file.removed": "File removed successfully.",
  "file.removed_error": "Something went wrong while removing file.",
  "file.data_upload.column_relationship": "column relationship",
  "file.download_sample_file": "Download sample file",

  // Buttons
  "btn.cancel": "cancel",
  "btn.submit": "submit",
  "btn.view": "view",
  "btn.edit": "edit",
  "btn.update": "update",
  "btn.close": "close",
  "btn.reset": "reset",
  "btn.next": "next",
  "btn.back": "back",
  "btn.ok": "ok",
  "btn.reject": "reject",
  "btn.delete": "delete",
  "btn.yes": "yes",
  "btn.no": "no",
  "btn.continue": "continue",
  "btn.export": "export",
  "btn.filter": "filter",
  "btn.download": "download",
  "btn.send_email": "send email",
  "btn.search": "search",
  "btn.save_search": "Save Search",
  "btn.enrich": "Enrich",
  "btn.saved": "Saved",
  "btn.exported": "Exported",

  //Login page
  "login.title": "Olympus login",
  "login.email": "email",
  "login.password": "password",
  "login.login": "Login",
  "login.remember_me": "remember me",
  "login.forgot_password_link": "Forgot your password?",

  //Forgot Password Page
  "forgot_password.title": "forgot password",
  "forgot_password.sub_title": "Please enter email address",
  "forgot_password.go_back_to": "Go back to",
  "forgot_password.login": " login",
  "forgot_password.email": "email",

  //Reset Password Page
  "reset_password.title": "reset password",
  "reset_password.sub_title": "Please enter new password below",
  "reset_password.new_password": "new password",
  "reset_password.confirm_password": "confirm password",
  "reset_password.show_password": "show password",
  "reset_password.hide_password": "hide password",

  //Generic page
  "generic_page.coming_soon.title": "coming soon",
  "generic_page.coming_soon.sub_title": "This page is under construction.",
  "generic_page.not_found.title": "not found",
  "generic_page.not_found.sub_title": "The requested page is not found.",

  // Date Range picker
  "date_range_picker.title": "date range",
  "date_range_picker.default_label": "select a date range",
  "date_range_picker.date_range": "{startDate} - {endDate}",

  // Profile
  "profile.title": "settings",
  "profile.change_password": "Change password",
  "profile.password": "Password",
  "profile.confirm_password": "Confirm password",
  "profile.profile_image": "Profile Image",
  "profile.upload_photo": "Upload Photo",

  // Data Search
  "data_search.title": "data search",
  "dataSearch.job_title": "Job Title",
  "dataSearch.job_seniority": "Job Seniority",
  "dataSearch.industry": "Industry",
  "dataSearch.region_country": "Region/Country",
  "dataSearch.company_size": "Company Size",
  "dataSearch.revenue": "Revenue",
  "dataSearch.department": "Department",
  "dataSearch.upload_tal": "Upload TAL",
  "dataSearch.search_data.table.column.contactable": "contactable",
  "dataSearch.search_data.table.column.employee": "employee",
  "dataSearch.search_data.table.column.company": "company",
  "dataSearch.search_data.table.column.email": "email",
  "dataSearch.search_data.table.column.phone": "phone",
  "dataSearch.search_data.table.column.job_title": "job title",
  "dataSearch.search_data.table.column.job_seniority": "job seniority",
  "dataSearch.search_data.chart.percent_on": "% ON",
  "dataSearch.search_data.chart.percent_off": "% OFF",

  "data_search.save_search.title": "Save search",
  "data_search.save_search.name": "search name",
  "data_search.applied_search_filters": "Applied Search Filters",
  "data_search.table.showing_records": "Showing Records: {totalRecords}",
  "data_search.save_search.error_search_already_saved": "Search already saved for applied filters. Please change filters to save search with new name.",
  "data_search.enrich_modal.title": "Data Search - Enrich",

  // Add Data
  "addData.title": "Add Data",
  "addData.tab.upload": "Upload",
  "addData.tab.scrape": "Scrape",
  "addData.tab.audit": "Audit Dashboard",
  "addData.leadScraper.title": "Lead Scraper",
  "addData.leadScraper.coming_soon": "Lead scraper feature is coming soon.",
  "addData.leadScraper.industry": "Industry",
  "addData.leadScraper.location": "Location",
  "addData.leadScraper.job_title": "Job Title",
  "addData.leadScraper.email_status": "Email Status",
  "addData.leadScraper.seniority_level": "Seniority Level",
  "addData.leadScraper.company_size": "Company Size",
  "addData.leadScraper.functional_level": "Functional Level",
  "addData.leadScraper.lead_count": "Lead Count",
  "addData.leadScraper.search_name": "Search Name",
  "addData.leadScraper.company_domain": "Company Domain",
  "addData.leadScraper.no_sheets_found": "No sheets found in the uploaded file.",
  "addData.leadScraper.no_valid_domains": "No valid domains found in the selected column. Please select a column which has a valid domain list.",
  "addData.leadScraper.select_domain_column": "Select Company Domain Column",
  "addData.leadScraper.sheet": "Worksheet",
  "addData.leadScraper.select_sheet": "Select Worksheet",
  "addData.leadScraper.column": "Column",
  "addData.leadScraper.select_column": "Select Column",
  "addData.leadScraper.preview_values": "Preview (top values)",
  "addData.leadScraper.domains_loaded": "domains loaded",
  "addData.leadScraper.job_title_note": "Enter each value on a new line.",

  // History
  "history.title": "history",
  "history.label.users": "Users",
  "history.label.saved_search": "Saved Search",
  "history.label.source": "Source",
  "history.table.status": "status",
  "history.table.date": "date",
  "history.table.search_id": "Search ID",
  "history.table.search_name": "search name",
  "history.table.source": "source",
  "history.table.records": "records",
  "history.table.costs": "costs",
  "history.table.criteria": "criteria",
  "history.table.user": "user",
  "history.table.action": "action",
  "history.table.criteria.view": "view",
  "history.table.criteria.job_seniority": "Job Seniority",
  "history.table.criteria.industry": "Industry",
  "history.table.criteria.region_country": "Region/Country",
  "history.table.criteria.company_size": "Company Size",
  "history.table.criteria.revenue": "Revenue",
  "history.table.criteria.department": "Department",
  "history.table.criteria.uploaded_tal_file": "Uploaded TAL file",
  "history.table.criteria.company_industry": "Company Industry",
  "history.table.criteria.contact_location": "Contact Location",
  "history.table.criteria.contact_job_title": "Contact Job Title",
  "history.table.criteria.email_status": "Email Status",
  "history.table.criteria.seniority_level": "Seniority Level",
  "history.table.criteria.size": "Company Size",
  "history.table.criteria.functional_level": "Functional Level",
  "history.table.criteria.company_domain": "Company Domain",

  // History > Export table
  "history.export_table.status": "status",
  "history.export_table.date": "date",
  "history.export_table.id": "ID",
  "history.export_table.export_name": "export name",
  "history.export_table.records": "records",
  "history.export_table.exported_by": "exported by",
  "history.export_table.source": "source",

  //Enrich
  "enrich.title": "enrich",
  "enrich.sub_title": "select your data",
  "enrich.append_options": "append options",
  "enrich.select_your_data": "select your data",
  "enrich.saved_data": "saved data",
  "enrich.data_source": "data source",
  "enrich.total_records": "Total Records: {totalRecords}",
  "enrich.success_modal.title": "Enrich request submitted",
  "enrich.success_modal.loading": "loading...",
  "enrich.success_modal.message_1": "The enrichment process has been initiated.",
  "enrich.success_modal.message_2": "You will receive an email as soon as the process is completed.",

  // Audit Dashboard
  "auditDashboard.title": "Audit Dashboard",

  // Audit Dashboard — KPI Cards
  "auditDashboard.kpi.total_scrapes": "Total Scrapes",
  "auditDashboard.kpi.success_percentage": "Success %",
  "auditDashboard.kpi.total_leads": "Total Leads",

  // Audit Dashboard — Filter Labels
  "auditDashboard.label.user": "User",
  "auditDashboard.label.status": "Status",

  // Audit Dashboard — Table Columns
  "auditDashboard.table.search_id": "Search ID",
  "auditDashboard.table.search_name": "Search Name",
  "auditDashboard.table.created_at": "Created At",
  "auditDashboard.table.status": "Status",
  "auditDashboard.table.lead_count": "Lead Count",
  "auditDashboard.table.scrape_count": "Scrape Count",
  "auditDashboard.table.user_name": "User Name",
  "auditDashboard.table.error_message": "Error",

  // Audit Dashboard — Charts
  "auditDashboard.chart.scrape_success_trend": "Scrape Success Trend",
  "auditDashboard.chart.lead_quality": "Lead Quality Distribution",

  // Audit Dashboard — Export
  "auditDashboard.btn.export_searches": "Export Searches",

};

